import { envConfig } from '../lib/env-config'

export const chaineWorkspaces = [
  '025fa515-0064-47c4-b532-374f3620c35a', // Chaine integrations and reporting workspace
  '9b79668a-3fca-4288-aa66-ceb0789c1f97', // Chaine tracking and copilot workspace
  '9cf333ba-7c94-4db6-be57-3f3c529b78f2', // Chaine UX and enablement
  '26ec52d8-9be2-4ccb-9c11-5b61fbc96c13', // Chaine alpha workspace
  '024b299b-a9f0-44ce-83c0-07acf13d47a9' // Chaine legacy workspace
]

export const containerFeatureWorkspaces = [
  ...chaineWorkspaces,
  '98d91b0d-c82c-41fc-b0f3-9796b552a317' // Container feature org rollout workspace
]

/**
 * The function is used to determine if a user should be filtered out of results due to the fact that they are a Chaine user, and the current workspace is not Chaine.
 *
 * @param email the email address to check
 * @param selectedWorkspaceID the current workspaceID that the user has selected
 *
 * @returns true if the user should be removed as a chaine user, otherwise returns false
 */
export const filterAsChaineUser = (params: {
  email: string | null | undefined
  selectedWorkspaceID: string | null
}) => {
  const { email, selectedWorkspaceID } = params
  //when the current environment is dev, do not filter
  if (envConfig.envStage === 'dev') return false
  //when the current workspace is staging, do not filter
  if (envConfig.envStage === 'staging') return false
  //when the current workspace is Chaine, do not filter
  if (selectedWorkspaceID && chaineWorkspaces.includes(selectedWorkspaceID)) return false
  //if there is no email, do not filter
  if (!email) return false
  //if there is email is an internal Chaine email, then filter
  if (email.includes('@chaineapp.com') || email.includes('@trychain.com')) {
    return true
  }
  return false
}

/**
 * The function is used to determine if a user is a Chaine user based on the workspaceID
 */
export const isChainWorkspace = (workspaceID: string | null) => {
  if (!workspaceID) return false
  return chaineWorkspaces.includes(workspaceID)
}

/**
 * Determines whether the container feature is enabled for the workspace.
 */
export const isContainerFeatureWorkspace = (workspaceID: string | null) => {
  if (!workspaceID) return false
  return containerFeatureWorkspaces.includes(workspaceID)
}

/**
 * The function is used to determine if a user is a beta user based on the user's email
 */
export const getIsBetaUser = (email: string) => {
  const betaUsersEmails = [
    'bsimmons@shipdlx.com',
    'kgiddings@shipdlx.com',
    'jyeager@shipdlx.com',
    'bbay@lgiinc.com',
    'brendan.mcdonald@bedrocklogistics.com'
  ]
  return betaUsersEmails.includes(email)
}

/**
 * The function is used to determine if a user is a Chaine internal user based on the user's email
 * @param email the email address to check
 * @returns true if the user is a Chaine internal user, false otherwise
 */
export const getIsChainInternalUser = (email: string) => {
  if (!email) return false
  return email.includes('@chaineapp.com') || email.includes('@trychain.com')
}

/**
 * Determines whether the current user can access the container feature.
 * Access is granted to Chaine internal users and workspaces explicitly enabled for the rollout.
 */
export const getCanAccessContainerFeature = (params: { email: string; workspaceID: string | null }) => {
  const { email, workspaceID } = params

  return getIsChainInternalUser(email) || isContainerFeatureWorkspace(workspaceID)
}
